import {useDispatch} from 'react-redux';
import {graphql, useMutation} from 'react-relay';

import type {deleteUserMutation} from '../../graphql/__generated__/deleteUserMutation.graphql';

import {setApiFeedback} from '../../state/common/actions';

const mutation = graphql`
  mutation deleteUserMutation($input: DeleteUserInput!) {
    deleteUser(input: $input) {
      clientMutationId
    }
  }
`;

function useDeleteUser(): [
  (userId: string, callback: () => void, onError?: (error: Error) => void) => void,
  boolean,
] {
  const dispatch = useDispatch();
  const [commit, isInFlight] = useMutation<deleteUserMutation>(mutation);

  return [
    (userId, callback, onError) => {
      commit({
        variables: {
          input: {
            userId,
          },
        },
        onCompleted() {
          callback();
        },
        onError(error) {
          dispatch(setApiFeedback({error: error}));
          console.error(error);
          onError?.(error);
        },
      });
    },
    isInFlight,
  ];
}

export default useDeleteUser;
